// API Configuration
// Реальный URL бэкенда должен приходить из .env/.env.local:
// VUE_APP_API_BASE_URL=https://your-backend-url/api

// const baseUrl = process.env.VUE_APP_API_BASE_URL || ''
const baseUrl = '/api'

if (!baseUrl) {
  // eslint-disable-next-line no-console
  console.warn('[API_CONFIG] VUE_APP_API_BASE_URL is not set. Please configure it in .env.local')
}

export const API_CONFIG = {
  BASE_URL: baseUrl
}
